import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

/**
 * AuthCallback — handles the OAuth return from Emergent.
 * The session_id arrives in the URL fragment (#session_id=...). We:
 *   1. Pull the session_id (synchronously during render via location.hash)
 *   2. POST it to /api/auth/session (sets httpOnly cookie)
 *   3. Strip the fragment + navigate to /
 *
 * Uses useRef to guard against StrictMode double-effects.
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const { exchangeSession } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        await exchangeSession(sessionId);
        // Strip the fragment, go home.
        const cleanUrl = window.location.pathname + window.location.search;
        window.history.replaceState({}, "", cleanUrl);
        navigate("/?stripe_check=1", { replace: true });
      } catch (e) {
        setError(String(e.message || e));
      }
    })();
  }, [exchangeSession, navigate]);

  return (
    <div
      data-testid="auth-callback"
      style={{
        position: "fixed",
        inset: 0,
        display: "grid",
        placeItems: "center",
        background: "#0b1530",
        color: "#f3ead4",
        fontFamily: "Georgia, 'Times New Roman', serif",
        zIndex: 10000,
      }}
    >
      <div style={{ textAlign: "center" }}>
        <div
          style={{
            fontSize: 11,
            letterSpacing: 4,
            color: "#e6b450",
            textTransform: "uppercase",
            marginBottom: 8,
          }}
        >
          The Academic Boardroom
        </div>
        <div style={{ fontSize: 18 }}>
          {error ? `Sign-in failed: ${error}` : "Signing you in…"}
        </div>
      </div>
    </div>
  );
}
